<ng-template #alertModal>
  <app-alert-modal
    [type]="params.alert?.type"
    [text]="params.alert?.text"
    [html]="params.alert?.html"
  ></app-alert-modal>
</ng-template>

<ng-template #confirmModal>
  <app-confirm-modal
    [title]="params.confirm?.title"
    [description]="params.confirm?.description"
    [dangerousHTML]="params.confirm?.dangerousHTML"
    [titleClass]="params.confirm?.titleClass"
    [confirmBtnClass]="params.confirm?.confirmBtnClass"
    [confirmBtnText]="params.confirm?.confirmBtnText"
    [cancelBtnClass]="params.confirm?.cancelBtnClass"
    [cancelBtnText]="params.confirm?.cancelBtnText"
    (cancel)="onConfirmCancel($event)"
    (confirm)="onConfirm()"
  ></app-confirm-modal>
</ng-template>

<ng-template #codeModal>
  <app-code-modal
    [type]="params.code?.type"
    [step]="params.code?.initialStep"
    [inputData]="params.code?.inputData"
    (dismiss)="onCodeModalDismiss()"
    (success)="onCodeModalSuccess()"
  ></app-code-modal>
</ng-template>

<ng-template #editPhotoModal>
  <app-edit-photo
    [image]="params.editPhoto?.image"
    (cancel)="closeModal()"
    (save)="onEditPhotoModalSave($event)"
  ></app-edit-photo>
</ng-template>

<ng-template #feedbackModal>
  <app-feedback-modal
    (submit)="onSubmitFeedback($event)"
    (dismiss)="closeModal()"
  ></app-feedback-modal>
</ng-template>

<ng-template #helpModal>
  <app-help-modal (dismiss)="closeModal()"></app-help-modal>
</ng-template>

<ng-template #fileUploadModal>
  <app-file-upload-modal
    [uploadType]="params.fileUpload?.uploadType"
    [title]="params.fileUpload?.title"
    [status]="params.fileUpload?.status"
    [complianceInfo]="params.fileUpload?.complianceInfo"
    [instructions]="params.fileUpload?.instructions"
    [rejectReason]="params.fileUpload?.rejectReason"
    [events]="params.fileUpload?.events"
    (submit)="onSubmitFileUpload($event)"
    (dismiss)="closeModal()"
  ></app-file-upload-modal>
</ng-template>

<ng-template #uploadTaskModal>
  <app-upload-task-modal
    [imageTypeId]="params.uploadTask?.imageTypeId"
    (dismiss)="onCloseUploadTask()"
  ></app-upload-task-modal>
</ng-template>
